export default "__VITE_ASSET__CViAHT5k__"